// directives/ripple.js
export const ripple = {
    selector: '[data-ripple]',
    reactive: false,
    run(el, data, root) { 
    }
};